import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    DeleteSmsCampaign as DeleteSmsCampaignMutation,
    DeleteSmsCampaignVariables,
} from 'nutshell-graphql-types';

import DELETE_SMS_CAMPAIGN from '../../../broadcasts/graphql/mutations/delete-sms-campaign.graphql';

import {dripSequenceDeleteRestoreUpdate} from '../../helpers';

export function useDeleteSmsDripSequence(): {
    deleteCampaign: (id: string) => Promise<any>;
    isDeleting: boolean;
    error: string | null | undefined;
} {
    const [deleteCampaign, {loading, error}] = useMutation<
        DeleteSmsCampaignMutation,
        DeleteSmsCampaignVariables
    >(DELETE_SMS_CAMPAIGN);

    return {
        deleteCampaign: (id: string) =>
            deleteCampaign({
                variables: {input: {id}},
                update: (proxy, mutationResults) => {
                    // Get the archived dripSequence
                    const archivedDripSequence =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.campaignDelete &&
                        mutationResults.data.campaignDelete.campaign;

                    if (!archivedDripSequence) return;

                    // @ts-expect-error
                    dripSequenceDeleteRestoreUpdate(proxy, archivedDripSequence, true);
                },
            }),
        isDeleting: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
